import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getUsers } from "../../redux/actions/Users";
import UsersFilter from "./UsersFilter";
import UserPage from "../UserPage/UserPage";
import LinkDropdown from "../../components/LinkDropdown/LinkDropdown";

const UsersPage = ({ getUsers, users }) => (
  <div>
    <h1>Users</h1>
    <UsersFilter
      onChange={e => {
        getUsers(e.target.value);
      }}
    />
    <LinkDropdown header={"Manage"}>
      <Link to="/user/create">Create</Link>
    </LinkDropdown>
    <table className="table table-sm table-responsive-md">
      <thead>
        <tr>
          <th>Name</th>
          <th>Username</th>
          <th>Last logged in</th>
        </tr>
      </thead>
      <tbody>
        {users.map((user, key) => (
          <tr key={key}>
            <td>
              <Link to={"/user/" + user.id}>{user.name}</Link>
            </td>
            <td>{user.username}</td>
            <td>{UserPage.renderLatestSession(user)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const mapStateToProps = ({ users }) => ({ users });

const mapDispatchToProps = dispatch => {
  return {
    getUsers: name => {
      return dispatch(getUsers(name));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPage);



// WEBPACK FOOTER //
// ./src/containers/UsersPage/UsersPage.js